var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag loading-tag",class:['loading-tag', 'success-tag', 'error-tag', 'error-tag'][_vm.row.task_status]},[_vm._v(_vm._s(_vm.taskStatus(_vm.row)))])
}
var staticRenderFns = []

export { render, staticRenderFns }